module.exports = __webpack_public_path__ + "img/home-1920.15f45950.webp";